import { render } from "./message-video.vue?vue&type=template&id=23f9759c&scoped=true&ts=true"
import script from "./message-video.vue?vue&type=script&lang=ts"
export * from "./message-video.vue?vue&type=script&lang=ts"

import "./message-video.vue?vue&type=style&index=0&id=23f9759c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f9759c"]])

export default __exports__